export const money = (value) => Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const cents = (value) => value === "" || value === null || value === undefined || !Number.isFinite(Number(value))
  ? null : Math.round((Number(value) + Number.EPSILON) * 100);

export function validateSalesPeriod(from, to, year) {
  const valid = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date)) &&
    new Date(date).toISOString().slice(0, 10) === date;
  if (!valid(from) || !valid(to)) return "Plotësoni të dy datat.";
  if (from < `${year}-01-01` || to > `${year}-12-31` || from > to || Date.parse(to) - Date.parse(from) > 31 * 86400000)
    return "Zgjidhni deri në 32 ditë përfshirëse brenda vitit fiskal.";
  return "";
}

export function normalizeSalesPreview(data, seller) {
  const fields = ["SalesTotal", "ReturnsTotal", "NetTotal", "Cash", "Bank", "Other", "PaymentDifference"];
  if (!data || data.Seller !== seller || !Array.isArray(data.Documents) || !Array.isArray(data.Payments) ||
      fields.some((field) => typeof data[field] !== "number" || !Number.isFinite(data[field])) ||
      !Number.isInteger(data.DocumentCount) || data.DocumentCount !== data.Documents.length)
    throw new Error("Përmbledhja e shitjeve nuk është valide.");
  const groups = new Map();
  data.Payments.forEach((payment) => {
    if (!Number.isInteger(payment.AccountID) || typeof payment.Amount !== "number" || !Number.isFinite(payment.Amount) ||
        !["Cash", "Bank", "Other"].includes(payment.Category)) throw new Error("Ndarja e pagesave nuk është valide.");
    const key = `${payment.LedgerID}:${payment.AccountID}`;
    const row = groups.get(key) || { ...payment, key, amountInCents: 0 };
    row.amountInCents += cents(payment.Amount);
    groups.set(key, row);
  });
  return { ...data, PaymentAccounts: Array.from(groups.values()).map((row) => ({ ...row, Amount: row.amountInCents / 100 })) };
}

export function compareReported(expected, reported) {
  const value = cents(reported);
  return value === null ? null : (value - cents(expected)) / 100;
}
